
import { mapActions } from 'vuex'
import { api, getJsonApiHeaders } from '~/config/api'
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    distributor: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      step: 1,
      loading: false,
    }
  },
  methods: {
    ...mapActions({
      SetDistributorList: 'catalog/SetDistributorList',
    }),
    async onUnlink() {
      try {
        this.loading = true
        await this.$store.dispatch('jvZen/delete', [
          `${api.PRACTICE_LOCATION_DISTRIBUTORS}/${this.distributor.practiceLocationDistributorId}`,
          getJsonApiHeaders(),
        ])
        this.step = 2
        await this.SetDistributorList
      } catch (e) {
        console.error('onUnlink', e)
      } finally {
        this.loading = false
      }
    },
    onClose() {
      this.$emit('close')
    },
  },
}
